export enum GravatarTypes {
  GravatarsRequest = 'gravatars/GRAVATARS_REQUEST',
  GravatarsSuccess = 'gravatars/GRAVATARS_SUCCESS',
  GravatarsFailure = 'gravatars/GRAVATARS_FAILURE',
}

export type GravatarMap = { [email: string]: string };
